import ReactDOM from 'react-dom';
import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useNavigate, useLocation } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import {
	AlertsManager,
	Button,
	Flex,
	GlobalStyles,
	H0,
} from '@bigcommerce/big-design';
import TabbedNavigation from './components/TabbedNavigation';
import { ClientProvider } from './context/client';
import { OrderStatusesProvider } from './context/OrderStatuses';
import { UserProvider } from './context/user';
import './global.css';
import * as middleware from './middleware';
import CallCenterPage from './pages/CallCenter';
import FitmentPage from './pages/Fitment';
import CSVExportsPage from './pages/csvExport';
import PhotoContestPage from './pages/PhotoContest/PhotoContestPage';
import OrdersEditorPage from './pages/Orders/OrdersEditor';
import OrdersListPage from './pages/Orders/OrdersList';
import { alertsManager } from './utils';

function App() {
	const navigate = useNavigate();
	const location = useLocation();

	// Parse query parameters to check for view_order parameter
	// This is used when opening orders in a new tab
	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const viewOrderId = params.get('view_order');
		
		if (viewOrderId) {
			// Navigate to the order page without adding to history stack
			// This prevents back button from going to the empty page
			navigate(`/orders/${viewOrderId}`, { replace: true });
		}
	}, [location.search, navigate]);

	return (
		<>
			<GlobalStyles />
			<div className="page-header">
				<H0>ShearComfort Admin</H0>
				<Flex
					justifyContent="space-between"
					style={{ paddingBottom: '1rem', gap: '1rem' }}
				>
					<TabbedNavigation
						routes={[
							{
								pathname: '/fitments',
								title: 'Fitment Database',
							},
							{ pathname: '/orders', title: 'Orders' },
							{ pathname: '/call-center', title: 'Call Center' },
							{ pathname: '/csv', title: 'CSV Exports' },
							{ pathname: '/photo-contest', title: 'Photo Contest' },
						]}
					/>
					<Button onClick={() => navigate('/call-center')}>
						Create New Order
					</Button>
				</Flex>
			</div>
			<main>
				<Routes>
					<Route path="fitments" element={<FitmentPage />} />
					<Route path="orders">
						<Route path=":id" element={<OrdersEditorPage />} />
						<Route index element={<OrdersListPage />} />
					</Route>
					<Route
						path="call-center"
						element={<CallCenterPage key={Date.now()} />}
					/>
					<Route
						path="csv"
						element={<CSVExportsPage />}
					/>
					<Route path="photo-contest" element={<PhotoContestPage />} />
					<Route
						path="*"
						element={<Navigate replace to="/orders" />}
					/>
				</Routes>
				<AlertsManager manager={alertsManager} />
			</main>
		</>
	);
}

ReactDOM.render(
	<BrowserRouter>
		<ClientProvider endpoints={middleware}>
			<UserProvider>
				<OrderStatusesProvider>
					<App />
				</OrderStatusesProvider>
			</UserProvider>
		</ClientProvider>
	</BrowserRouter>,
	document.getElementById('app'),
);
